export default "__VITE_ASSET__b5785974__"